import styled, { keyframes, css } from 'styled-components';
import { isDefaultTheme } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var fadeIn = keyframes(["from{opacity:0;}to{opacity:0.8;}"]);
var fadeOut = keyframes(["from{opacity:0.8;}to{opacity:0;}"]);
var slideIn = keyframes(["from{top:0;}to{top:var(--top-margin);}"]);
var slideOut = keyframes(["from{opacity:1;top:var(--top-margin);}to{opacity:0;top:0;}"]);
var Modal = styled.dialog.withConfig({
  displayName: "Modalstyle__Modal",
  componentId: "sc-gbr05y-0"
})(["overflow:hidden;margin-inline:auto;--top-margin:7vh;--max-height:calc(100vh - var(--top-margin) * 2);@media (min-aspect-ratio:21/9){--top-margin:2vh;}", " ", " ", " &::backdrop{background:#202020;opacity:0;}", " ", " scrollbar-width:thin;scrollbar-color:var(--color-almostblack) var(--color-white);::-webkit-scrollbar{width:6px;background-color:var(--color-white);}::-webkit-scrollbar-thumb{background-color:var(--color-almostblack);border-radius:4px;}"], isDefaultTheme(css(["", ""], mq.s(css(["border-radius:var(--border-radius-500);"])))), mq.sMax(css(["height:100%;max-height:100%;top:0;max-width:100%;width:100%;"])), mq.s(css(["max-height:var(--max-height);width:calc((1280px - var(--space-grid-margin) * 2) * (10 / 12));", " ", ""], function (_ref) {
  var $size = _ref.$size;
  return $size === 'l' && css(["width:calc((1280px - var(--space-grid-margin) * 2));"]);
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size === 's' && css(["width:calc((1280px - var(--space-grid-margin) * 24));"]);
})), function (_ref3) {
  var $isOpen = _ref3.$isOpen;
  return $isOpen && css(["", ""], mq.s(css(["top:var(--top-margin);animation-name:", ";animation-duration:0.25s;&::backdrop{opacity:0.8;animation-name:", ";animation-duration:0.25s;}"], slideIn, fadeIn)));
}, function (_ref4) {
  var $isClosing = _ref4.$isClosing;
  return $isClosing && css(["", ""], mq.s(css(["top:0;animation-name:", ";animation-duration:0.25s;&::backdrop{opacity:0;animation-name:", ";animation-duration:0.25s;}"], slideOut, fadeOut)));
});
var ModalContentContainer = styled.div.withConfig({
  displayName: "Modalstyle__ModalContentContainer",
  componentId: "sc-gbr05y-1"
})(["", ""], mq.sMax(css(["height:100%;"])));
var ModalContent = styled.div.withConfig({
  displayName: "Modalstyle__ModalContent",
  componentId: "sc-gbr05y-2"
})(["display:flex;flex-direction:column;", " ", ""], mq.sMax(css(["height:100%;"])), mq.s(css(["max-height:var(--max-height);height:fit-content;"])));
var Header = styled.div.withConfig({
  displayName: "Modalstyle__Header",
  componentId: "sc-gbr05y-3"
})(["background:var(--color-white);"]);
var HeaderContent = styled.div.withConfig({
  displayName: "Modalstyle__HeaderContent",
  componentId: "sc-gbr05y-4"
})([""]);
var Top = styled.div.withConfig({
  displayName: "Modalstyle__Top",
  componentId: "sc-gbr05y-5"
})(["display:flex;justify-content:", ";gap:var(--space-300);align-items:center;", ";", ";", ""], function (_ref5) {
  var $hasHeading = _ref5.$hasHeading;
  return $hasHeading ? 'space-between' : 'end';
}, function (_ref6) {
  var $overlaidCloseButton = _ref6.$overlaidCloseButton;
  return $overlaidCloseButton ? css(["padding:0px;"]) : css(["padding:var(--space-400);", ""], mq.s(css(["padding:var(--space-600);"])));
}, function (_ref7) {
  var $isInDrawer = _ref7.$isInDrawer;
  return $isInDrawer && css(["padding-top:0;"]);
}, function (_ref8) {
  var $hasHeading = _ref8.$hasHeading;
  return !$hasHeading && css(["padding-bottom:0;", " ", ""], mq.s(css(["padding-bottom:0;"])), mq.m(css(["padding-bottom:0;"])));
});
var Heading = styled.h2.withConfig({
  displayName: "Modalstyle__Heading",
  componentId: "sc-gbr05y-6"
})(["font:var(--font-headline-m);"]);
var Content = styled.div.withConfig({
  displayName: "Modalstyle__Content",
  componentId: "sc-gbr05y-7"
})(["overflow-y:auto;scrollbar-width:thin;scrollbar-color:var(--color-almostblack) var(--color-white);height:100%;", ";::-webkit-scrollbar{width:6px;background-color:var(--color-white);}::-webkit-scrollbar-thumb{background-color:var(--color-almostblack);border-radius:4px;}"], function (_ref9) {
  var $noContentPadding = _ref9.$noContentPadding,
    $overlaidCloseButton = _ref9.$overlaidCloseButton;
  return $noContentPadding ? css(["padding:0px;"]) : css(["padding:0px var(--space-400) var(--space-400);", " ", ""], mq.s(css(["padding:0px var(--space-600) var(--space-600);"])), $overlaidCloseButton && mq.m(css(["padding:0px var(--space-700) var(--space-700);"])));
});
var CloseButton = styled.button.withConfig({
  displayName: "Modalstyle__CloseButton",
  componentId: "sc-gbr05y-8"
})(["", ";line-height:0;"], function (_ref10) {
  var $overlaidCloseButton = _ref10.$overlaidCloseButton;
  return $overlaidCloseButton ? css(["position:absolute;top:var(--space-500);right:var(--space-500);padding:var(--space-100);background:rgba(0,0,0,0.7);transition:background var(--transition);svg{color:var(--color-white);}", " &:hover{background:rgba(0,0,0,0.9);}"], isDefaultTheme(css(["border-radius:var(--border-radius-200);"]))) : css(["padding:var(--space-100);"]);
});

export { CloseButton, Content, Header, HeaderContent, Heading, Modal, ModalContent, ModalContentContainer, Top };
//# sourceMappingURL=Modal.style.js.map
